import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError, retryWhen, tap } from 'rxjs/operators';
// eslint-disable-next-line max-len
import { LaboratorySpecificSetting } from '../modules/admin/components/shared/components/laboratory-specific-settings/models/laboratory-specific-setting.model';
import { ActionForm } from './dtos/actionForm';
import { ActionWithSettings } from './dtos/actionWithSettings';
import { genericRetryStrategy } from './retry-strategy';

@Injectable({ providedIn: 'root' })
export class ActionsService {
  private actionsUrl = this.baseUrl + '/api/actions';

  public constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    @Inject('API_BASE_URL') private baseUrl: string) { }

  public getAllBasicInfo(): Observable<ActionWithSettings[]> {
    return this.http.get<ActionWithSettings[]>(this.actionsUrl + '/GetAllBasicInfo')
      .pipe(
        retryWhen(genericRetryStrategy()),
      );
  }

  public getAction(id: string): Observable<ActionWithSettings> {
    return this.http.get<ActionWithSettings>(this.actionsUrl + '/Get/' + id)
      .pipe(
        catchError(this.handleError<ActionWithSettings>('getAction'))
      );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public updateAction(actionToUpdate: ActionForm): Observable<any> {
    return this.http.put(this.actionsUrl + '/Update/' + actionToUpdate.id, actionToUpdate)
      .pipe(
        tap(() => this.toastr.success('Saved Sucessfully')),
        catchError(this.handleError<ActionForm>('updateAction'))
      );
  }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public addActionLaboratorySpecificSetting(settings: LaboratorySpecificSetting): Observable<any> {
    return this.http.post(this.actionsUrl + '/AddActionLaboratorySpecificSetting/', settings)
      .pipe(
        tap(() => this.toastr.success('Saved Sucessfully')),
        catchError(this.handleError<ActionForm>('addActionLaboratorySpecificSetting'))
      );
  }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public updateActionLaboratorySpecificSetting(settings: LaboratorySpecificSetting): Observable<any> {
      return this.http.post(this.actionsUrl + '/UpdateActionLaboratorySpecificSetting/', settings)
        .pipe(
          tap(() => this.toastr.success('Saved Sucessfully')),
          catchError(this.handleError<ActionForm>('updateActionLaboratorySpecificSetting'))
        );
    }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      public deleteActionLaboratorySpecificSetting(actionId: string, settingId: string): Observable<any> {
        return this.http.delete(this.actionsUrl + '/DeleteActionLaboratorySpecificSetting/' + actionId + `/` + settingId)
          .pipe(
            tap(() => this.toastr.success('Saved Sucessfully')),
            catchError(this.handleError<ActionForm>('deleteActionLaboratorySpecificSetting'))
          );
      }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  private handleError<T>(operation = 'operation', result?: T | undefined): (err: any) => Observable<T> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error: any): Observable<T> => {
      console.error('An error occurred', error);
      this.toastr.error(`${operation} failed: ${error.message}`);

      throw error;
    };
  }
}
